"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jobTitles = exports.cityNames = exports.companyNames = exports.familyNames = exports.givenNames = exports.notificationContexts = exports.notificationActions = exports.notificationContextData = exports.notificationData = exports.genieTypeData = exports.statusData = exports.statusCategoryData = void 0;
const statusCategoryData = [{
  category: 'final',
  class: 'final-1',
  display: 'Final Stages'
}, {
  category: 'final',
  class: 'final-2',
  display: 'Final Stages'
}, {
  category: 'interview',
  class: 'interview-1',
  display: 'Interviewing'
}, {
  category: 'interview',
  class: 'interview-2',
  display: 'Interviewing'
}, {
  category: 'action-required',
  class: 'action-required',
  display: 'Action Required'
}, {
  category: 'potential',
  class: 'potential',
  display: 'Potential / On Hold'
}, {
  category: 'passed',
  class: 'passed',
  display: 'Passed / Rejected'
}, {
  category: 'out-of-process',
  class: 'out-of-process',
  display: 'Out of Process'
}];
exports.statusCategoryData = statusCategoryData;
const statusData = [{
  category: 'final',
  class: 'final-1',
  status: 'Placement',
  display: 'Placement',
  clientVisible: true
}, {
  category: 'final',
  class: 'final-1',
  status: 'Offer Accepted',
  display: 'Offer Accepted',
  clientVisible: true,
  clientAllowedNext: ['Offer Pulled']
}, {
  category: 'final',
  class: 'final-2',
  status: 'Offer',
  display: 'Offer',
  clientVisible: true,
  clientAllowedNext: ['Offer Pulled']
}, {
  category: 'final',
  class: 'final-2',
  status: 'Offer Pending',
  display: 'Offer Pending',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Offer', 'Offer Pulled', 'Personality Assessmt', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'interview',
  class: 'interview-1',
  status: '12th Interview Set',
  display: '12th Interview Set',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Offer', 'Offer Pending', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'interview',
  class: 'interview-1',
  status: '11th Interview Set',
  display: '11th Interview Set',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Offer', 'Offer Pending', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'interview',
  class: 'interview-1',
  status: '10th Interview Set',
  display: '10th Interview Set',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Offer', 'Offer Pending', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'interview',
  class: 'interview-1',
  status: '09th Interview Set',
  display: '9th Interview Set',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Offer', 'Offer Pending', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'interview',
  class: 'interview-1',
  status: '08th Interview Set',
  display: '8th Interview Set',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Offer', 'Offer Pending', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'interview',
  class: 'interview-1',
  status: '07th Interview Set',
  display: '7th Interview Set',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Offer', 'Offer Pending', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'interview',
  class: 'interview-1',
  status: '06th Interview Set',
  display: '6th Interview Set',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Offer', 'Offer Pending', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'interview',
  class: 'interview-1',
  status: '05th Interview Set',
  display: '5th Interview Set',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Offer', 'Offer Pending', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'interview',
  class: 'interview-1',
  status: '04th Interview Set',
  display: '4th Interview Set',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Offer', 'Offer Pending', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'interview',
  class: 'interview-2',
  status: '03rd Interview Set',
  display: '3rd Interview Set',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Offer', 'Offer Pending', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'interview',
  class: 'interview-2',
  status: '02nd Interview Set',
  display: '2nd Interview Set',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Offer', 'Offer Pending', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'interview',
  class: 'interview-2',
  status: '01st Interview Set',
  display: '1st Interview Set',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Offer', 'Offer Pending', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'action-required',
  class: 'action-required',
  status: 'Need Availability',
  display: 'Need Availability',
  clientVisible: true
}, {
  category: 'action-required',
  class: 'action-required',
  status: 'Need Int Feedback',
  display: 'Need Interview Feedback',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Offer', 'Offer Pending', 'On Hold/Reapproach', 'Personality Assessmt', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'action-required',
  class: 'action-required',
  status: 'Need Resume Feedback',
  display: 'Need Resume Feedback',
  clientVisible: true,
  clientAllowedNext: ['Approach Assignment', 'Client Not Intereste', 'Not Appropriate', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'action-required',
  class: 'action-required',
  status: 'Interested',
  display: 'Interested',
  clientVisible: true,
  clientAllowedNext: ['Client Not Intereste', 'Not Appropriate', 'Personality Assessmt', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'action-required',
  class: 'action-required',
  status: 'Interviewed w/Client',
  display: 'Interviewed with Client',
  clientVisible: true,
  clientAllowedNext: ['Not Appropriate', 'Offer', 'Offer Pending', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'action-required',
  class: 'action-required',
  status: 'Set Up Interview',
  display: 'Set Up Interview',
  clientVisible: true,
  clientAllowedNext: ['Client Not Intereste', 'Need Availability', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Test/Assignment']
}, {
  category: 'action-required',
  class: 'action-required',
  status: 'Personality Assessmt',
  display: 'Personality Assessment',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Client Not Intereste', 'Not Appropriate', 'Offer', 'Offer Pending', 'On Hold/Reapproach', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'action-required',
  class: 'action-required',
  status: 'Qualifying',
  display: 'Qualifying',
  clientVisible: true,
  clientAllowedNext: ['Approach Assignment', 'Client Not Intereste', 'Not Appropriate', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'action-required',
  class: 'action-required',
  status: 'Test/Assignment',
  display: 'Test / Assignment',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Client Not Intereste', 'Not Appropriate', 'Offer', 'Offer Pending', 'On Hold/Reapproach', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'action-required',
  class: 'action-required',
  status: 'Approach Assignment',
  display: 'Approach Assignment',
  clientVisible: true,
  clientAllowedNext: ['Client Met & Passed', 'Client Not Intereste', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'potential',
  class: 'potential',
  status: 'AutoEntry',
  display: 'AutoEntry',
  clientVisible: false
}, {
  category: 'potential',
  class: 'potential',
  status: 'On Hold/Reapproach',
  display: 'On Hold / Reapproach',
  clientVisible: true,
  clientAllowedNext: ['Approach Assignment', 'Client Met & Passed', 'Client Not Intereste', 'Not Appropriate', 'Personality Assessmt', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'potential',
  class: 'potential',
  status: 'Potential',
  display: 'Potential',
  clientVisible: false,
  clientAllowedNext: ['Approach Assignment', 'Client Not Intereste', 'Not Appropriate', 'On Hold/Reapproach', 'Personality Assessmt', 'Priored', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'potential',
  class: 'potential',
  status: 'Research',
  display: 'Research',
  clientVisible: false,
  clientAllowedNext: ['01st Interview Set', 'Approach Assignment', 'On Hold/Reapproach', 'Personality Assessmt', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'potential',
  class: 'potential',
  status: 'Source',
  display: 'Source',
  clientVisible: false,
  clientAllowedNext: ['Approach Assignment']
}, {
  category: 'potential',
  class: 'potential',
  status: 'Web Submission',
  display: 'Web Submission',
  clientVisible: false,
  clientAllowedNext: ['On Hold/Reapproach', 'Personality Assessmt', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'passed',
  class: 'passed',
  status: 'Cand Met & Passed',
  display: 'Candidate Met & Passed',
  clientVisible: true
}, {
  category: 'passed',
  class: 'passed',
  status: 'Client Met & Passed',
  display: 'Client Met & Passed',
  clientVisible: true,
  clientAllowedNext: ['On Hold/Reapproach', 'Set Up Interview']
}, {
  category: 'passed',
  class: 'passed',
  status: 'Counter Offer',
  display: 'Counter Offer',
  clientVisible: true
}, {
  category: 'passed',
  class: 'passed',
  status: 'Offer Pulled',
  display: 'Offer Pulled',
  clientVisible: true,
  clientAllowedNext: ['Offer', 'Offer Pending', 'Personality Assessmt', 'Set Up Interview', 'Test/Assignment']
}, {
  category: 'passed',
  class: 'passed',
  status: 'Offer Rejected',
  display: 'Offer Rejected',
  clientVisible: true,
  clientAllowedNext: ['Offer', 'Offer Pending', 'On Hold/Reapproach', 'Set Up Interview']
}, {
  category: 'out-of-process',
  class: 'out-of-process',
  status: 'Cand Not Interested',
  display: 'Candidate Not Interested',
  clientVisible: true
}, {
  category: 'out-of-process',
  class: 'out-of-process',
  status: 'Client Not Intereste',
  display: 'Client Not Interested',
  clientVisible: true,
  clientAllowedNext: ['On Hold/Reapproach', 'Set Up Interview']
}, {
  category: 'out-of-process',
  class: 'out-of-process',
  status: 'Hands off',
  display: 'Hands Off',
  clientVisible: true
}, {
  category: 'out-of-process',
  class: 'out-of-process',
  status: 'Not Appropriate',
  display: 'Not Appropriate',
  clientVisible: true,
  clientAllowedNext: ['Approach Assignment', 'On Hold/Reapproach', 'Set Up Interview']
}, {
  category: 'out-of-process',
  class: 'out-of-process',
  status: 'Priored',
  display: 'Priored',
  clientVisible: true,
  clientAllowedNext: ['Approach Assignment', 'On Hold/Reapproach', 'Set Up Interview']
}, {
  category: 'client-team',
  class: 'client-team',
  status: 'Hiring Manager',
  display: 'Hiring Manager',
  clientVisible: false
}, {
  category: 'client-team',
  class: 'client-team',
  status: 'Interviewer',
  display: 'Interviewer',
  clientVisible: false
}];
exports.statusData = statusData;
const genieTypeData = [{
  category: 'interview',
  class: 'interview-1',
  type: '12th Interview',
  display: '12th Interview',
  clientVisible: false
}, {
  category: 'interview',
  class: 'interview-1',
  type: '11th Interview',
  display: '11th Interview',
  clientVisible: false
}, {
  category: 'interview',
  class: 'interview-1',
  type: '10th Interview',
  display: '10th Interview',
  clientVisible: false
}, {
  category: 'interview',
  class: 'interview-1',
  type: '09th Interview',
  display: '9th Interview',
  clientVisible: false
}, {
  category: 'interview',
  class: 'interview-1',
  type: '08th Interview',
  display: '8th Interview',
  clientVisible: false
}, {
  category: 'interview',
  class: 'interview-1',
  type: '07th Interview',
  display: '7th Interview',
  clientVisible: false
}, {
  category: 'interview',
  class: 'interview-1',
  type: '06th Interview',
  display: '6th Interview',
  clientVisible: false
}, {
  category: 'interview',
  class: 'interview-1',
  type: '05th Interview',
  display: '5th Interview',
  clientVisible: false
}, {
  category: 'interview',
  class: 'interview-1',
  type: '04th Interview',
  display: '4th Interview',
  clientVisible: false
}, {
  category: 'interview',
  class: 'interview-2',
  type: '03rd Interview',
  display: '3rd Interview',
  clientVisible: false
}, {
  category: 'interview',
  class: 'interview-2',
  type: '02nd Interview',
  display: '2nd Interview',
  clientVisible: false
}, {
  category: 'interview',
  class: 'interview-2',
  type: '01st Interview',
  display: '1st Interview',
  clientVisible: false
}, {
  category: 'potential',
  class: 'potential',
  type: 'Bio',
  display: 'Bio',
  clientVisible: true
}, {
  category: 'potential',
  class: 'potential',
  type: 'Write-Up',
  display: 'Write Up',
  clientVisible: true
}, {
  category: 'client-team',
  class: 'potential',
  type: 'Client Feedback',
  display: 'Client Feedback',
  clientVisible: true
}];
exports.genieTypeData = genieTypeData;
const notificationData = [{
  action: 'flagCandidate',
  pref_name: 'Candidate was Flagged',
  plural: 'Candidates Flagged'
}, {
  action: 'updateCandidate',
  pref_name: 'Candidate Updates',
  plural: 'Candidate Updates'
}, {
  action: 'requestCandidate',
  pref_name: 'Candidate Requests',
  plural: 'Candidate Requests'
}, {
  action: 'requestSearch',
  pref_name: 'Search Requests',
  plural: 'Search Requests'
}, {
  action: 'addCandidate',
  pref_name: 'New Candidates',
  plural: 'New Candidates'
}, {
  action: 'addSearch',
  pref_name: 'New Searches',
  plural: 'New Searches'
}];
exports.notificationData = notificationData;
const notificationContextData = [{
  context: 'inApp',
  display: 'App'
}, {
  context: 'email',
  display: 'Email'
}];
exports.notificationContextData = notificationContextData;
const notificationActions = notificationData.map(d => d.action);
exports.notificationActions = notificationActions;
const notificationContexts = notificationContextData.map(d => d.context);
exports.notificationContexts = notificationContexts;
const givenNames = ['Bob', 'John', 'George', 'Ringo', 'Melinda', 'Asa', 'Vi', 'Tencia', 'Anne', 'Margaret', 'Ryan', 'Chanick', 'Richard', 'Dan', 'Dana', 'Janet', 'Jackson', 'Kevin', 'Adel', 'Marco', 'Jose', 'Schlomo', 'Ezra', 'Darren', 'Tammy', 'Pamela', 'Melissa', 'Burke', 'Bruce', 'Benjamin'];
exports.givenNames = givenNames;
const familyNames = ['Park', 'Yee', 'Lee', 'Smith', 'Nguyen', 'Sanders', 'Montegue', 'Jorgensen', 'Chambers', 'Tran', 'Mina', 'Bernard', 'Trounton-Smith', 'Johnson', 'McDonald', 'DeBlasio'];
exports.familyNames = familyNames;
const companyNames = ['Google', 'Tower', 'Citi Group', 'Apple Inc.', 'New York City Mayor\'s Office', 'IBM', 'Uber', 'Buzz Media, Inc.', 'BNP Paribas', 'Credit Suisse', 'HQ Media, Inc.', 'Facebook', 'Amazon', 'PWC', 'Wells Fargo'];
exports.companyNames = companyNames;
const cityNames = ['New York', 'London', 'Belfast', 'Cupertino', 'Los Angeles', 'Seoul', 'Chicago', 'Atlanta', 'Houston', 'Dallas', 'San Jose', 'Boston', 'Philadelphia', 'Tokyo', 'Hong Kong', 'Singapore', 'Seattle', 'San Francisco', 'St Louis'];
exports.cityNames = cityNames;
const jobTitles = ['Account Executive', 'Application Developer', 'Account Manager', 'Architect', 'Account Representative', 'Art Director', 'Accountant', 'Assembler', 'Accounting Assistant', 'Assistant', 'Accounting Clerk', 'Assistant Controller', 'Accounting Manager', 'Assistant Editor', 'Accounts Payable Clerk', 'Assistant Manager', 'Accounts Payable Specialist', 'Assistant Project Manager', 'Accounts Receivable Clerk', 'Assistant Property Manager', 'Administrative Assistant', 'Assistant Store Manager', 'Administrative Coordinator', 'Assistant Teacher', 'Administrative Specialist', 'Attorney', 'Analyst', 'Autocad Drafter', 'Analytical Chemist', 'Automotive Technician', 'Baker', 'Broadband Technician', 'Bank Teller', 'Budget Analyst', 'Banker', 'Bus Driver', 'Banquet Manager', 'Business Analyst', 'Bartender', 'Business Developer', 'Benefits Administrator', 'Business Development Associate', 'Benefits Manager', 'Business Development Manager', 'Benefits Specialist', 'Business Development Specialist', 'Billing Clerk', 'Business Manager', 'Billing Specialist', 'Business Objects Developer', 'Bookkeeper', 'Business Office Manager', 'Branch Customer Service Representative', 'Business Process Analyst', 'Branch Manager', 'Business Systems Analyst', 'Branch Office Administrator', 'Buyer', 'Brand Manager', 'Buyer Planner', 'Carpenter', 'Construction Manager', 'Case Manager', 'Construction Superintendent', 'Cashier', 'Construction Worker', 'Certified Nursing Assistant', 'Contract Specialist', 'Chemist', 'Controller', 'Chief Financial Officer', 'Cook', 'Civil Engineer', 'Copywriter', 'Clerk', 'Counselor', 'Clinical Pharmacist', 'Credit Analyst', 'Cna', 'Criminal Investigator', 'Cnc Machinist', 'Custodian', 'Commercial Sales Manager', 'Customer Service Advisor', 'Communications Specialist', 'Customer Service Associate', 'Community Volunteer', 'Customer Service Manager', 'Computer Scientist', 'Customer Service Representative', 'Data Analyst', 'Director Of Communication', 'Data Entry Clerk', 'Director Of Development', 'Data Entry Operator', 'Director Of Finance', 'Database Administrator', 'Director Of Human Resources', 'Delivery Driver', 'Director Of Marketing', 'Dental Assistant', 'Director Of Nursing', 'Dental Hygienist', 'Director Of Operations', 'Design Engineer', 'Director Of Sales', 'Designer', 'Dishwasher', 'Desktop Support', 'Dispatcher', 'Desktop Support Technician', 'District Manager', 'Development Associate', 'District Sales Manager', 'Diesel Mechanic', 'Drafter', 'Director', 'Driver', 'Director Of Business Development', 'Driver Merchandiser', 'Editor', 'Environmental Engineer', 'Editorial Assistant', 'Environmental Scientist', 'Electrical Designer', 'Equipment Operator', 'Electrical Engineer', 'Escrow Assistant', 'Electrician', 'Esthetician', 'Electronic Assembler', 'Estimator', 'Electronics Engineer', 'Event Manager', 'Electronics Technician', 'Event Planner', 'Embedded Software Engineer', 'Executive Administrative Assistant', 'Emergency Road Service Counselor', 'Executive Assistant', 'Engineer', 'Executive Chef', 'Engineering Manager', 'Executive Director', 'Engineering Technician', 'Executive Personal Assistant', 'Enrollment Counselor', 'Executive Recruiter', 'Enterprise Architect', 'Executive Secretary'];
exports.jobTitles = jobTitles;